import React, { useEffect, useState } from 'react';
import { View, StyleSheet, StatusBar, Image } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { KeyboardProvider } from 'react-native-keyboard-controller';
import AppNavigator from './src/navigation/AppNavigator';
import ApiService from './src/services/ApiService';
import AnalyticsService from './src/services/AnalyticsService';
import { AuthProvider } from './src/contexts/AuthContext';
import { theme } from './src/constants/theme';

const logo = require('./src/assets/logo.png');

function App() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        // Initialize API service and wait for 2 seconds simultaneously
        await Promise.all([
          ApiService.init(),
          AnalyticsService.init(),
          new Promise(resolve => setTimeout(() => resolve(true), 2000))
        ]);
        console.log('App initialized successfully');
      } catch (error) {
        console.error('Failed to initialize app:', error);
      } finally {
        setIsReady(true);
      }
    };

    initializeApp();
  }, []);

  if (!isReady) {
    return (
      <View style={styles.splashContainer}>
        <StatusBar barStyle="light-content" />
        <Image
          source={logo}
          style={styles.logo}
          resizeMode="contain"
        />
      </View>
    );
  }

  return (
    <SafeAreaProvider>
      <KeyboardProvider>
        <AuthProvider>
          <StatusBar
            barStyle="light-content"
          // backgroundColor={theme.colors.primary}
          />
          <AppNavigator />
        </AuthProvider>
      </KeyboardProvider>
    </SafeAreaProvider>
  );
}

const styles = StyleSheet.create({
  splashContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.background,
  },
  logo: {
    width: 250,
    height: 250,
  },
});

export default App;
